import { Roles } from "../store/role";

function useRoles(): [typeof Roles] {
  return [Roles];
}

export default useRoles;
